{
  "it": {
    "analytics": {
      "labels": {
        "allUnits": "Tutte le unità",
        "click_seen_by": "Faccia clic per maggiori informazioni",
        "click_shared_with": "Faccia clic per vedere quali clienti l'hanno visto",
        "deleted": "Eliminato",
        "deleted_item": "Questo elemento è stato eliminato e non è più cliccabile",
        "noCustomers": "Nessun cliente è ancora assegnato a questo livello.",
        "noCustomersSeen": "Nessun cliente lo ha ancora visto.",
        "noCustomersUnseen": "Tutti i clienti lo hanno visto.",
        "noUnitAccess": "Nessun accesso all'unità",
        "notSeen": "Non visto ({number})",
        "seen": "Visto ({number})",
        "seenAt": "Visto il {date}",
        "seenBy": "Visto da",
        "seen_by_all": "Visto da tutti. Faccia clic per vedere chi lo ha visto.",
        "sharedWithMultipleUnits": "Condiviso con nessuna unità in {level_name} | Condiviso con 1 unità in {level_name} | Condiviso con {units_count} unità in {level_name}",
        "sharedWithUnit": "Condiviso con {unit_name}",
        "units": "Nessuna unità | Un'unità | {count} unità",
        "unseenOfTotal": "{unseen} di {total} non lo hanno ancora visto",
        "views": "Visualizzazioni",
        "viewsCount": "Nessuna visualizzazione | 1 visualizzazione | {count} visualizzazioni",
        "whoSeenAnnouncement": "Chi ha visto questa novità"
      }
    }
  }
}
